export default __webpack_public_path__ + "static/media/DO.5e6ab1c3.svg";